// /src/mixins/questionMixin.js

import resizeMixin from '@/mixins/resizeMixin'
import { mapGetters } from 'vuex'


export default {
    mixins: [resizeMixin],
    data() {
        return {
            includeQuestion: false,
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/getUser',
        }),
        
        acceptedUsers() {
            const { user } = this
            const users = [ 2, 4, 16, 18, 44, 166 ]
            if (users.includes(user.id)) return true
            return false
        },      
    },

    methods: {

        handleResize() {
            this.includeQuestion = this.screen.width < 1425
        },
    
    },

    mounted() {
        this.handleResize()
    },

    created() {
        window.addEventListener('resize', this.handleResize)
    },

    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
}

